import React from "react";
import "./NumberContiner.scss";

interface IProps {
    name: string;
}

const NumberContiner = (props: IProps) => {
    return (
        <div className="userful-number-container">
            <h1>{props.name}</h1>
        </div>
    );
};

export default NumberContiner;
